// Products are DB-driven now: the API returns each icon as a string *name*
// (e.g. "LocationCity") instead of a component. This registry maps those names
// back to MUI icon components. When a product starts using a new icon, add its
// import here too.

import LocationCity from "@material-ui/icons/LocationCity";
import Contacts from "@material-ui/icons/Contacts";
import School from "@material-ui/icons/School";
import TrendingUp from "@material-ui/icons/TrendingUp";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
import Language from "@material-ui/icons/Language";
import Android from "@material-ui/icons/Android";
import Apple from "@material-ui/icons/Apple";
import Widgets from "@material-ui/icons/Widgets";
import Description from "@material-ui/icons/Description";
import ViewColumn from "@material-ui/icons/ViewColumn";
import AccountTree from "@material-ui/icons/AccountTree";
import Brush from "@material-ui/icons/Brush";
import GridOn from "@material-ui/icons/GridOn";
import Functions from "@material-ui/icons/Functions";
import BrandingWatermark from "@material-ui/icons/BrandingWatermark";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import MergeType from "@material-ui/icons/MergeType";
import CallSplit from "@material-ui/icons/CallSplit";
import Layers from "@material-ui/icons/Layers";
import Archive from "@material-ui/icons/Archive";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import Lock from "@material-ui/icons/Lock";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Storage from "@material-ui/icons/Storage";
import Build from "@material-ui/icons/Build";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Forum from "@material-ui/icons/Forum";
import People from "@material-ui/icons/People";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import AlternateEmail from "@material-ui/icons/AlternateEmail";
import AttachFile from "@material-ui/icons/AttachFile";
import Search from "@material-ui/icons/Search";
import Notifications from "@material-ui/icons/Notifications";
import CloudOff from "@material-ui/icons/CloudOff";
import TrackChanges from "@material-ui/icons/TrackChanges";
import MyLocation from "@material-ui/icons/MyLocation";
import Storefront from "@material-ui/icons/Storefront";
import Business from "@material-ui/icons/Business";
import Grade from "@material-ui/icons/Grade";
import Sort from "@material-ui/icons/Sort";
import EmojiEvents from "@material-ui/icons/EmojiEvents";
import Public from "@material-ui/icons/Public";
import Star from "@material-ui/icons/Star";
import LocalShipping from "@material-ui/icons/LocalShipping";
import SportsEsports from "@material-ui/icons/SportsEsports";
import Schedule from "@material-ui/icons/Schedule";
import Speed from "@material-ui/icons/Speed";
import DirectionsCar from "@material-ui/icons/DirectionsCar";
import FlashOn from "@material-ui/icons/FlashOn";
import TouchApp from "@material-ui/icons/TouchApp";
import Terrain from "@material-ui/icons/Terrain";
import Security from "@material-ui/icons/Security";

export const PRODUCT_ICONS = {
  LocationCity, Contacts, School, TrendingUp, SwapHoriz, BusinessCenter,
  Language, Android, Apple, Widgets, Description, ViewColumn, AccountTree,
  Brush, GridOn, Functions, BrandingWatermark, VerifiedUser, MergeType,
  CallSplit, Layers, Archive, PictureAsPdf, Lock, AttachMoney, Storage,
  Build, MonetizationOn, Forum, People, ChatBubbleOutline, AlternateEmail,
  AttachFile, Search, Notifications, CloudOff, TrackChanges, MyLocation,
  Storefront, Business, Grade, Sort,
  EmojiEvents, Public, Star, LocalShipping,
  SportsEsports, Schedule,
  Speed, DirectionsCar, FlashOn, TouchApp, Terrain, Security,
};

// Accepts a stored icon name (string) or an already-imported component and
// always returns a renderable component (falls back to Widgets if unknown).
export const resolveIcon = (icon) =>
  (typeof icon === "string" ? PRODUCT_ICONS[icon] : icon) || Widgets;
